import styles from './DocumentsSelector.module.scss';
import { IDocument } from '../../../../../models/document';
import DocumentsTableList from '../../Pages/Documents/Components/DocumentTableList';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import ReactModal from 'react-modal';
import DocumentsExplorer, { DocumentsExplorerProps } from './DocumentsExplorer';

function DocumentExplorerModal({
  savId,
  multi = true,
  selectedDocuments,
  onChangeSelectedDocuments,
  onRequestClose,
  zIndex,
  ...props
}: Omit<ReactModal.Props, 'isOpen' | 'onRequestClose'> & {
  savId: number;
  multi?: boolean;
  onRequestClose: () => void;
  zIndex?: number;
} & DocumentsExplorerProps) {

  const [newSelectedDocuments, setNewSelectedDocuments] = useState<IDocument[]>([]);

  const handleAddDocuments = () => {
    if (onChangeSelectedDocuments) {
      onChangeSelectedDocuments([...(selectedDocuments || []), ...newSelectedDocuments]);
    }
    setNewSelectedDocuments([]);
    onRequestClose();
  }

  return (
    <ReactModal
      {...props}
      onRequestClose={onRequestClose}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      isOpen={true}
      ariaHideApp={false}
      style={{
        overlay: {
          zIndex: zIndex ?? 100000,
        },
        content: {
          display: "flex",
          flexDirection: "column",
          ...(isMobile ? {inset: "0px"} : {}),
        }
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title">Ajouter des documents</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onRequestClose}></button>
      </div>

      <div className="modal-body" style={{flex :1}}>
        <DocumentsExplorer
          savId={savId}
          hideIds={(selectedDocuments || []).map(document => document.id)}
          selectedDocuments={newSelectedDocuments}
          onChangeSelectedDocuments={(documents) => {
            setNewSelectedDocuments(documents);
            if (!multi) {
              onChangeSelectedDocuments?.(documents);
              onRequestClose();
            }
          }}
        />
      </div>

      {multi && (
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleAddDocuments}>Ajouter ({newSelectedDocuments.length})</button>
      </div>
      )}

    </ReactModal>
  )
}

export default function DocumentsSelector({
  savId,
  labelBtn = 'Ajouter un document',
  selectMulti = true,
  documentsSelected,
  onChangeSelectedDocuments,
  hideList = false,
  readOnly = false,
  zIndex,
  containerProps: { className, ...containerProps } = {}
}: {
  savId: number;
  labelBtn?: string;
  selectMulti?: boolean;
  documentsSelected: IDocument[];
  onChangeSelectedDocuments: (documents: IDocument[]) => void;
  hideList?: boolean;
  zIndex?: number;
  readOnly?: boolean;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
}) {

  const [displayModal, setDisplayModal] = useState(false);

  // Display a button to add a document to the list
  return (
    <div {...containerProps} className={`${styles.container} ${className}`}>
      {displayModal && (
        <DocumentExplorerModal
          savId={savId}
          zIndex={zIndex}
          multi={selectMulti}
          onRequestClose={() => setDisplayModal(false)}
          selectedDocuments={documentsSelected}
          onChangeSelectedDocuments={onChangeSelectedDocuments}
        />
      )}

      {!readOnly && (<button
        className="btn btn-primary"
        type="button"
        onClick={() => setDisplayModal(true)}
      >{labelBtn}</button>)}

      {!hideList && selectMulti && documentsSelected.length > 0 && (
        <DocumentsTableList
          data={documentsSelected || []}
          actions={readOnly ? [] : [
            {
              label: 'Retirer',
              onClick: async (document: IDocument) => {
                onChangeSelectedDocuments(documentsSelected.filter(selectedDocument => selectedDocument.id !== document.id));
              }
            }
          ]}
        />
      )}

    </div>
  )
}

export { DocumentExplorerModal };